export default __webpack_public_path__ + "static/media/HomeImage5.d4b5cc8f.svg";